import { FclQuote } from "./quote-fcl.model";

export class BrokerageQuote extends FclQuote {}
